import { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '34607282943';

export const WhatsAppFloat = () => {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 30000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (visible && !dismissed) {
      const expandTimer = setTimeout(() => setExpanded(true), 500);
      return () => clearTimeout(expandTimer);
    }
  }, [visible, dismissed]);

  const handleClick = () => {
    const msg = 'Ola, tenho duvidas sobre meu caso migratorio. Pode me ajudar?';
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    setExpanded(false);
    setDismissed(true);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="whatsapp-float">
      <AnimatePresence>
        {expanded && !dismissed && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.9 }}
            className="absolute bottom-16 right-0 w-72 bg-[#0a0c10] border border-[#C9A24A]/30 rounded-lg shadow-2xl shadow-black/50 p-4 cursor-pointer"
            onClick={handleClick}
          >
            <button
              onClick={handleDismiss}
              className="absolute top-2 right-2 text-gray-500 hover:text-white"
              data-testid="whatsapp-dismiss"
            >
              <X className="w-3.5 h-3.5" />
            </button>
            <p className="text-white text-sm font-medium mb-1">Duvidas sobre seu caso?</p>
            <p className="text-gray-400 text-xs">Fale com o especialista Diogo Fortunato no WhatsApp. Resposta rapida.</p>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleClick}
        className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:shadow-[#25D366]/50 transition-shadow"
        data-testid="whatsapp-btn"
      >
        <MessageCircle className="w-7 h-7 text-white" />
      </motion.button>
    </div>
  );
};
